import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const pillVariants = cva(
	"inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-primary text-primaryForeground hover:bg-primary/80",
				secondary:
					"border-transparent bg-secondary text-secondaryForeground hover:bg-secondary/80",
				outline: "border-border text-foreground hover:bg-accent",
				success:
					"border-transparent bg-statusSuccess text-primaryForeground hover:bg-statusSuccess/80",
				warning:
					"border-transparent bg-statusWarning text-foreground hover:bg-statusWarning/80",
				info: "border-transparent bg-statusInfo text-primaryForeground hover:bg-statusInfo/80",
				destructive:
					"border-transparent bg-destructive text-destructiveForeground hover:bg-destructive/80",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface PillProps
	extends HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof pillVariants> {}

const Pill = forwardRef<HTMLSpanElement, PillProps>(
	({ className, variant, ...props }, ref) => (
		<span
			ref={ref}
			className={cn(pillVariants({ variant }), className)}
			{...props}
		/>
	),
);
Pill.displayName = "Pill";

export default Pill;
export { Pill };
